const environment =
  (process.env.GOOGLE_PAY_ENVIRONMENT as 'TEST' | 'PRODUCTION') || 'TEST';

const paymentMethodsParameters = {
  allowedAuthMethods: process.env.GOOGLE_PAY_ALLOWED_AUTH_METHODS?.split(
    ',',
  ) as google.payments.api.CardAuthMethod[],
  allowedCardNetworks: process.env.GOOGLE_PAY_ALLOWED_CARD_NETWORKS?.split(
    ',',
  ) as google.payments.api.CardNetwork[],
  billingAddressRequired: true,
  assuranceDetailsRequired: true,
};

// Gateway configuration
const gateway = process.env.GOOGLE_PAY_GATEWAY as string;
const gatewayMerchantId = process.env.GOOGLE_PAY_GATEWAY_MERCHANT_ID as string;

const merchantInfo = {
  merchantId: process.env.GOOGLE_PAY_MERCHANT_ID as string,
  merchantName: process.env.GOOGLE_PAY_MERCHANT_NAME as string,
};

export default async function useGooglePay(totalPrice: number) {
  const paymentsClient = new window.google.payments.api.PaymentsClient({
    environment,
  });

  const paymentDataRequest: google.payments.api.PaymentDataRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: 'CARD',
        parameters: paymentMethodsParameters,
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: gateway,
            gatewayMerchantId: gatewayMerchantId,
          },
        },
      },
    ],
    merchantInfo,
    transactionInfo: {
      totalPriceStatus: 'FINAL',
      totalPriceLabel: 'Total',
      totalPrice: totalPrice.toString(),
      currencyCode: 'BRL',
      countryCode: 'BR',
    },
  };

  try {
    const paymentData = await paymentsClient.loadPaymentData(
      paymentDataRequest,
    );

    return paymentData;
  } catch (err) {
    // TODO: add to sentry
    console.error('Erro ao carregar GPay', err);
  }
}
